import React from "react";
import { Link } from "react-router-dom";
import { StarRating } from "./StarRating";
import { BookCover } from "./BookCover";
import { useI18n } from "@/contexts/I18nContext";

/**
 * A book in a grid or shelf. No box around it: the cover is the object, and
 * the title and author sit under it the way they would on a bookshop table.
 */
export const BookCard = ({ book, eager = false }) => {
  const { lang } = useI18n();
  const title = lang === "hi" ? book.title_hi : (book.title_en || book.title_hi);
  const author = book.authors?.[0];
  const authorName = author ? (lang === "hi" ? author.name_hi : author.name_en || author.name_hi) : "";
  const rated = (book.review_count || 0) > 0;
  return (
    <Link to={`/books/${book.slug}`} data-testid={`book-card-${book.slug}`} className="group block min-w-0">
      <BookCover
        src={book.cover_image} title={title} eager={eager}
        className="rounded-[var(--radius)] shadow-[var(--cover-shadow)]"
      />
      <h3 className="mt-3 text-[1.02rem] leading-snug line-clamp-2 group-hover:text-primary group-focus-visible:text-primary">
        {title}
      </h3>
      {authorName && <p className="mt-0.5 text-sm text-muted-foreground line-clamp-1">{authorName}</p>}
      {rated && (
        <p className="mt-1 flex items-center gap-1.5 text-xs text-muted-foreground">
          <StarRating value={book.avg_rating} size={12} />
          <span>{Number(book.avg_rating).toFixed(1)} ({book.review_count})</span>
        </p>
      )}
    </Link>
  );
};

/** Loading stand-in with a card's full height (cover, two title lines, author), so rows don't grow when books arrive. */
export const BookCardSkeleton = () => (
  <div aria-hidden="true">
    <div className="aspect-[2/3] skel" />
    <div className="mt-3 h-[2.75em] text-[1.02rem]"><div className="skel h-[1em] w-4/5" /></div>
    <div className="mt-0.5 h-5"><div className="skel h-3.5 w-1/2" /></div>
  </div>
);
